"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = void 0;
var _reactSelect = require("react-select");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ValueContainer = (0, _styledComponents.default)(_reactSelect.components.ValueContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-weight: 500;\n  padding: 0 !important;\n  color: ", ";\n  border: none;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
exports.ValueContainer = ValueContainer;